import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const client_secret = process.env.REACT_APP_CLIENT_SECRET_LOGIN
const client_id = process.env.REACT_APP_CLIENT_ID_LOGIN
const grant_type = process.env.REACT_APP_GRANT_TYPE_LOGIN

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify_token`
export const LOGIN_URL = `${API_URL}/oauth/newtoken`
export const LOGIN_MASTER = `${API_URL}/oauth/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const RESET_PASSWORD_URL = `${API_URL}/reset_password`

// Server should return AuthModel
export function login(username: string, password: string) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  const params:any = {
    username,
    password,
    client_secret,
    client_id,
    grant_type,
  }
  const data = Object.keys(params)
  .map((key) => `${key}=${encodeURIComponent(params[key])}`)
  .join('&');

  return axios.post<AuthModel>(LOGIN_URL, data, { headers })
}

export function verifyRutApi(rut: string) {
  return axios.post(`${API_URL}/verify_rut`, {rut})
}

export function sendCodeIdentity(type: string, rut: string) {
  return axios.post(`${API_URL}/send_code_identity`, {type, rut})
}

export function verifyCodeIdentity(type: string, code: string, rut: string) {
  return axios.post(`${API_URL}/verify_code_identity`, {type, code, rut})
}

const createFormData = (state: any) => {
  const data = new FormData();

  // Función auxiliar para manejar objetos anidados
  const appendNestedObject = (obj: any, prefix = '') => {
    Object.entries(obj).forEach(([key, value]) => {
      // Construir la clave con el prefijo si existe
      const fieldName = prefix ? `${prefix}.${key}` : key;

      if (value !== null && value !== undefined) {
        // Si es un objeto pero NO es un archivo
        if (typeof value === 'object' && !(value instanceof File)) {
          appendNestedObject(value, fieldName);
        }
        // Si es un archivo o cualquier otro tipo de dato
        else {
          data.append(fieldName, value instanceof File ? value : String(value));
        }
      }
    });
  };

  appendNestedObject(state);
  return data;
};

export function createSolicitud(formData: any) {
  
  const data = createFormData(formData);

  return axios.post(`${API_URL}/create_solicitud`, data, {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
  });
}

export function respoderSolicitud(datos: any) {
  const formData = createFormData({
    id_solicitud: datos.id_solicitud,
    archivos: datos.archivos.map((archivo: any) => ({
      file: archivo.archivo,
      tipo: archivo.tipo,
    })),
    info_adicional: datos.info_adicional,
  });

  return axios.post(`${API_URL}/responder_solicitud`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}



export function getBanks() {
  return axios.get(`${API_URL}/list_banks`);
}
export function getCiudades() {
  return axios.get(`${API_URL}/list_cities`);
}
export function getComunas() {
  return axios.get(`${API_URL}/list_communes`);
}
export function getRegiones() {
  return axios.get(`${API_URL}/list_regions`);
}

export function consultarSolicitud(codigo: string, rut: string) {
  return axios.post(`${API_URL}/consultar_solicitud`, {codigo, rut});
}

export function loginMasterApi(userMaster: any) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  const params:any = {...userMaster,
    client_secret,
    client_id,
    grant_type,
  }
  const data = Object.keys(params)
  .map((key) => `${key}=${encodeURIComponent(params[key])}`)
  .join('&');

  return axios.post<AuthModel>(LOGIN_MASTER, data, { headers })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

export function requestPasswordReset(rut: string) {
  return axios.post<{status: boolean; message: string}>(REQUEST_PASSWORD_URL, {
    rut,
  })
}

export function resetPassword(token: string, password: string, password_confirmation: string) {
  return axios.post<{status: boolean; message: string}>(RESET_PASSWORD_URL, {
    token,
    password,
    password_confirmation,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}
